export default {
  ACCEPTED_FORMATS: '(Formats acceptés : JPEG, PNG, JPG)',
  ACTIONS: 'Actions',
  ACTIVE: 'Actif',
  ADD: 'Ajouter',
  ADD_PRODUCTS: 'Ajouter des produits',
  ADD_SUPPLIER: 'Ajouter un fournisseur',
  ADDING_NEW_CATEGORY_DETAILS: "Ajout détails d'une nouvelle catégorie...",
  ADDING_NEW_NOTE: "Ajout d'une nouvelle note...",
  ADDING_NEW_ORDER: "Ajout d'une nouvelle commande...",
  ADDING_PRODUCTS_TO_THE_DRAFT: "Ajout de produits à l'appel d'offres ...",
  ADDRESS: 'Adresse',
  APPLY: 'Appliquer',
  AUTHENTICATING: 'Authentification en cours ...',

  BACK_ORDER: 'Commande en attente',
  BACK_ORDER_ID: 'Identifiant de la commande en attente',
  BAKEASY_STORE_PORTAL: 'Portail Client Order-EZ',
  BASIC_DETAILS: 'Détails de base',
  BILL_DATE: 'Date de la facture',

  CANCEL: 'Annuler',
  CATEGORY: 'Catégorie',
  CHANGE_PASSWORD: 'Changer le mot de passe',
  CHECK: 'Vérifier',
  CITY: 'Ville',
  CLEAR: 'Effacer',
  COMMENTS: 'Commentaires',
  COMPANY_ADDRESS: 'Adresse de la compagnie',
  COMPANY_NAME: 'Nom compagnie',
  COMPOSE: 'Composer',
  CONFIRM_PASSWORD: 'Confirmer le mot de passe',
  CONTACT_SUPPORT: 'Veuillez contacter le support technique du système',
  CONTENT: 'Contenu',
  COST_PRICE: 'Prix de revient',
  COUNTRY: 'Pays',
  CREATE: 'Créer',
  CREATE_ORDER: 'Créer une commande',
  CREATED_DATE: 'Date de création',
  CURRENT_PASSWORD: 'Mot de passe actuel',
  CUSTOMER: 'Client',

  DATE_MM_DD_YYYY: 'Date',
  DATE_TO_BE_DELIVERED: 'Date de livraison',
  DELETE: 'Supprimer',
  DELETE_MESSAGE_CONFIRMATION:
    'Êtes-vous sûr(e) de vouloire supprimer ce message?',
  DELETING_MESSAGE: 'Suppression du message...',
  DELIVERY_DATE: 'Date de livraison',
  DESCRIPTION: 'Description',

  DOWNLOAD_SUCCESS: 'Succès du téléchargement',
  DOWNLOADING_ORDERS: 'Téléchargement des commandes...',
  DOWNLOADING_PRODUCT_DETAILS: 'Téléchargement des détails du produit...',
  DOWNLOADING_PRODUCTS: 'Téléchargement des produits...',
  DUE_DATE: "Date d'échéance",
  DUPLICATE: 'Reproduire',

  EDIT: 'Éditer',
  EMAIL: 'Adresse e-mail',
  EMAIL_ID: 'Identifiant e-mail',
  ENTER: 'Éditer ',
  ESTIMATED_SHIPPING_CHARGES: "Estimation des frais d'expédition",
  ESTIMATED_TAXES_1: 'Estimation des taxes 1',
  ESTIMATED_TAXES_2: 'Estimation des taxes 2',
  EXPECTED_DATE: 'Estimation de la date',
  EXPORT: 'Exportation',

  FETCHING_CATEGORIES: 'Recherche des catégories...',
  FETCHING_CATEGORIES_DETAILS: 'Recherche des détails des catégories...',
  FETCHING_CREATE_ORDERS: 'Recherche des commandes créées...',
  FETCHING_DRAFT_ORDER: 'Recherche des commandes provisoires...',
  FETCHING_INVOICE_DETAILS: 'Recherche des détails de facturation...',
  FETCHING_INVOICES: 'Recherche des factures...',
  FETCHING_MESSAGE_STATUS: "Recherche de l'état du message...",
  FETCHING_MESSAGES: 'Recherche des messages...',
  FETCHING_NAMES: 'Recherche des noms...',
  FETCHING_ORDERHISTORY_DETAILS:
    "Recherche des détails de l'historique des commandes...",
  FETCHING_PRODUCTS: 'Recherche des produits...',
  FETCHING_REPLIES: 'Recherches des réponses...',
  FETCHING_SHIPPINGS: 'Recherche des expéditions...',
  FETCHING_SHIPPINGS_DETAILS: "Recherche des détails de l'expédition...",
  FETCHING_STORES_DETAILS: 'Recherche détails Clients en cours…',
  FETCHING_SUPPLIER_DETAILS: 'Recherche des détails du fournisseur...',
  FETCHING_SUPPLIERS: 'Recherche des fournisseurs …',

  FILTER: 'Filtre',
  FORGOT_PASSOWRD: 'Mot de passe oublié ?',
  FROM: 'De',

  GENERAL_PRODUCT_COST: 'Coût général du produit',
  GENERATE: 'Générer',
  GETUSER_PROFILE: 'Obtenir le profil utilisateur...',
  GoToOrderForm: 'Revenir au formulaire de commande',
  GO_BACK_TO_ORDER_DETAILS: 'Revenir aux détails de la commande',
  GO_BACK_TO_ORDER_FORM: 'Revenir au formulaire de commande',

  HIGH_PRIORITY: 'Priorité élevée',
  IS_NOT_SAME: "N'est pas le même",
  INACTIVE: 'Inactif',
  INGREDIENT_IMAGE: "Image de l'ingrédient",
  INGREDIENT_LABEL_IMAGE: "Image de l'étiquette des ingrédients",
  INGREDIENT_NAME: "Nom de l'ingrédient",
  INGREDIENTS: 'Ingrédients',

  INVOICE__ID: 'Identifiant de la facture',
  INVOICE_ID: 'Identifiant de la facture',
  INVOICE_DATE: 'Date de la facturation',
  INVOICE_FILTER: 'Filtre sur facture',
  INVOICED_DATE: 'Date de la facture',
  INVOICED_VALUE: 'Valeur facturée',
  INVOICES: 'Factures',
  IS_REQUIRED: 'est requis',
  INVOICE_DETAILS: 'Détails de la facture',

  LANGUAGE: 'Langue',
  LOGOUT: 'Déconnexion',

  MEASURE_PER_UNITS: 'Mesure par unité',
  MEASURE_TYPE: 'Type de mesure',
  MEDIA_IMAGE: 'Médias (image)',
  MESSAGE_COMPOSE: "Rédaction d'un message",
  MESSAGE_FILTERS: 'Filtres message',
  MESSAGES: 'Messages',
  MESSAGES_THREAD: 'Fil de messages',
  METHOD: 'Méthode',
  MOBILE: 'Mobile',
  MODIFYING_LANGUAGE: 'Modification de la langue...',
  MODIFYING_PROFILE: 'Modification du profil...',

  NAME: 'Nom',
  NEW: 'Nouveau',
  NEW_MESSAGE: 'Nouveau message',
  NEW_ORDER_SUMMARY: 'Sommaire de la nouvelle commande',
  NEW_PASSWORD: 'Nouveau mot de passe',
  NO: 'Non',
  NO_SUBORDERS_PRESENT: 'Aucun sous‑ordre présent',
  NO_DATA_FOUND: 'Aucune donnée disponible',
  NORMAL: 'Normal',
  NOT_APPLICABLE: 'Non applicable',
  NOTE: 'Remarques',
  NOTE_CREATED_SUCCESSFULLY: 'Note créée avec succès',
  NUTRITION_IMAGE: "Image de l'étiquette nutritionnelle",
  NUTRITION_LABEL_IMAGE: "Image de l'étiquette nutritionnelle",

  OK: 'Ok',
  ORDER_BY: 'Commande par',
  ORDER_CANCEL_CONFIRM_MESSAGE:
    'Êtes-vous sûr(e) de vouloir annuler cette commande ?',
  ORDER_DATE: 'Date de la commande',
  ORDER_DETAILS: 'Détails de la commande',
  ORDER_FORM: 'Formulaire de commande',
  ORDER_HISTORY: 'Historique des commandes',
  ORDER_HISTORY_FILTER: "Filtre sur l'historique des commandes",
  ORDER_ID: 'Identifiant de commande',
  ORDER_INFO: 'Information sur la commande',
  ORDER_STATUS: 'Statut de la commande',
  ORDER_VALUE: 'Valeur de la commande',
  ORDERED_DATE: 'Date de la commande passée',
  ORDERS: 'Commandes',
  OTHER_DETAILS: 'Autres détails',

  PASSWORD: 'Mot de passe',
  PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Mot de passe principal mis à jour avec succès, déconnexion...',
  PAYMENT: 'Paiement',
  PAYMENT_TERMS: 'Conditions de paiement',
  PAYMENT_DUE_DATE: "Date d'échéance du paiement",
  PHONE: 'Téléphone',

  PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS:
    'Veuillez ajouter la quantité aux produits sélectionnés',
  PLEASE_ENTER_DESCRIPTION: 'Veuillez saisir la description',
  PLEASE_ENTER_SUBJECT: 'Veuillez saisir le sujet',
  PLEASE_ENTER_VALID: 'Veuillez vérifier la validité du ',
  PLEASE_ENTER_VALID_CREDINALS: 'Veuillez saisir des références valides',

  PLEASE_SELECT_AT_LEAST_ONE_PRODUCT:
    'Veuillez sélectionner au moins un produit',
  PLEASE_SELECT_NAME: 'Veuillez sélectionner un nom',
  PLEASE_SELECT_PRODUCTS_TO_ADD_TO_CART:
    'Veuillez sélectionner les produits à ajouter au panier',
  PLEASE_UPLOAD:
    "Veuillez télécharger une image d'une taille inférieure à 2 MB",

  PO_NUMBER: "Numéro du bon de commande d'achat",
  POSTAL_CODE: 'Code postal',
  PREFERRED_SHIPPING_METHOD: "Mode d'expédition souhaité",
  PRICE: 'Prix',
  PRINT: 'Imprimer',
  PRIORITY: 'Priorité',
  PROCESS_ORDER_ID: "Identifiant de l'ordre de traitement",

  PRODUCT: 'Produit',
  PRODUCT_DETAILS: 'Détails du produit',
  PRODUCT_FILTER: 'Filtre produit',
  PRODUCT_ID: 'Identifiant du produit',
  PRODUCT_IMAGE: 'Image du produit',
  PRODUCT_NAME: 'Nom du produit',
  PRODUCT_QUANTITY: 'Quantité du produit',
  PRODUCT_STATUS: 'Statut du produit',
  PRODUCT_TYPE: 'Type du produit',
  PRODUCTS: 'Produits',
  PROFILE: 'Profil',
  PROFILE_SETTINGS: 'Profil et paramètres',

  QR_: '# QR',
  QR_CODE: 'Code QR',
  QUANTITY: 'Quantité',
  QUANTITY_INVOICED: 'Quantité facturée',
  QUANTITY_ORDERED: 'Quantité commandée',
  QUANTITY_PER_UNIT: 'Quantité par unité',
  QUANTITY_SHIPPED: 'Quantité expédiée',

  READ: 'Lu',
  RECIPE_BUILDER: 'Créateur de recettes',
  RECIPE_BUILDER_REPORT: 'Rapport du créateur de recettes',
  RECIPE_BUILDER_TYPE: 'Type de créateur de recettes',
  REMEMBER_ME: 'Se souvenir de moi',
  REPLY: 'Répondre',
  REPORTS: 'Rapports',
  REQUESTED_DATE: 'Date souhaitée',
  REQUESTED_DELIVERY_DATE: 'Date de livraison souhaitée',
  RETAIL_PRICE: 'Prix de détail',
  ROWS_PER_PAGE: 'Lignes par page',

  SAVE: 'Sauvegarder',
  SAVE_CHANGES: 'Enregistrer les modifications',
  SAVE_TO_CART: 'Sauvegarder dans le panier',
  SEARCH: 'Rechercher',
  SELECT: 'Sélectionner ',
  SELECT_CATEGORY: 'Sélectionner la catégorie',
  SELECT_FROM: 'Sélectionner parmi',
  SELECT_LANGUAGE: 'Sélectionner la langue',
  SELECT_RECIPE_BUILDER: 'Sélectionner le créateur de recettes',
  SELECT_SUBCATEGORY: 'Sélectionner Sous-catégorie',
  SELECT_TO: 'Sélectionner pour',
  SEND: 'Envoyer',
  SENT: 'Envoyé',
  SEND_ORDER: 'Envoyer la commander',
  SENDING_MESSAGES: 'Envoi de messages...',
  SENDING_REPLIES: 'Envoi de réponses...',
  SET_AS_HIGH_PRIORITY: 'Priorité élevée',

  SHIP_TO: 'Expédier à',
  SHIPPED_DATE: "Date de l'expédition passée",
  SHIPPED_VIA: 'Expédié via',
  SHIPPING: 'Expédition',
  SHIPPING_CALCULATION: "Calcul de l'expédition",
  SHIPPING_CHARGE: "Tarif d'expédition",
  SHIPPING_CHARGES: "Tarifs d'expédition",
  SHIPPING_DATE: "Date d'expédition",
  SHIPPING_DETAILS: "Détails d'expédition",
  SHIPPING_FILTER: "Filtre d'expédition",
  SHIPPING_FORM: "Sélectionner Formulaire d'expédition",
  SHIPPING_ID: "Identifiant d'expédition",
  SHIPPING_MEMOS: "Mémos d'expédition",
  SHIPPING_METHOD: "Méthode d'expédition",
  SHIPPING_RATE: "Frais d'expédition",
  SIGN_IN: 'Se connecter',
  SIGN_IN_PORTAL: 'Portail de connexion Clients à Order-EZ',
  SKU_IMAGE: 'Image UGS',
  SKU_IMAGEL: '# UGS',
  SKU_NUMBER: 'Numéro UGS (Unité de Gestion de Stock)',
  SKU_ID: 'Identifiant UGS',

  STATE: 'État/Province',
  STATUS: 'Statut',
  STORE_ID: 'Identifiant Client',
  STORE_COST: 'Frais Client',
  STORE_DETAILS: 'Détails Client',
  STORE_NOTE: 'Remarque Client',
  STORE_NOTES: 'Remarques Client',
  STORE_PO: 'Bon de commande Client',
  STORE_PO_NUMBER: 'Numéro Bon de commande Client',
  STORE_PROFILE: 'Profil Client',
  STORE_NAME: 'Nom Client',
  STORE_TAX1: 'Nom de la taxe Client (1)',
  STORE_TAX1_RATE: 'Nom de la taxe Client (1)',
  STORE_TAX2: 'Nom de la taxe Client (2)',
  STORE_TAX2_RATE: 'Nom de la taxe Client (2)',
  STORES: 'Clients',
  STATE_PROVINCE: 'État/Province',

  SUB_CATEGORY: 'Sous-catégorie',
  SUB_TOTAL: 'Sous-total',
  SUBCATEGORY: 'Sous-catégorie',
  SUBJECT: 'Objet',
  SUBORDER_ID: 'Identifiant de la sous-commande',

  SUPPLIER: 'Fournisseur',
  SUPPLIER_DETAILS: 'Détails du fournisseur',
  SUPPLIER_NAME: 'Nom du fournisseur',
  SUPPLIER_NOTES: 'Notes du fournisseur',
  SUPPLIER_VIA: 'Fournisseur via',
  SUPPLIERS: 'Fournisseurs',

  TAG: 'Étiquette',
  TAXES: 'Taxes',
  TERMS: 'Conditions',
  TO: 'À',
  TOTAL: 'Total',
  TOTAL_INVOICE: 'Total de la facture',
  TOTAL_PRICE: 'Prix total',
  TOTAL_ORDER_VALUE: 'Valeur totale de la commande',
  TOTAL_REQUIRED: 'Total requis',
  TO_BE_CONFIRMED: 'À confirmer',

  UNIT: 'Unité',
  UNIT_OF_MEASURE: 'Unités de mesure',
  UNIT_PRICE: 'Prix unitaire',
  UPDATE_CATEGORY_DETAILS: 'Mise à jour des détails de la catégorie...',
  UPDATING_SUBCATEGORIES_DETAILS:
    'Mise à jour des détails de la sous-catégorie...',
  UPLOAD: 'Télécharger',
  UPLOADING_PROFILE_IMAGE: "Téléchargement de l'image du profil...",
  URGENT: 'Urgent',
  USERNAME: "Nom d'utilisateur",

  VERSION: 'Version',
  VIEW_ALL: 'Voir tout',
  YES: 'Oui',
  VIEW_REPLY: 'Voir / Répondre',
  NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS:
    'Remarque : vous pouvez saisir jusqu’à 500 caractères.',
  NO_SUPPLIER_NOTES_AVAILABLE: 'Aucune note du fournisseur disponible ',
  SELECT_HIGH_PRIORITY: 'Sélectionner Priorité élevée',
  ENTER_STORE_PO_NUMBER: 'Saisir Numéro Bon de commande Client',
  ENTER_NOTE: 'Saisir une note',
  SELECT_SUB_CATEGORY: 'Sélectionner Sous-catégorie',
  SELECT_PRODUCT: 'Sélectionner Nom du produit',
  ENTER_STORE_COST: 'Saisir Prix Client',
  SELECT_STATE: 'Sélectionne État',
  SELECT_COUNTRY: 'Sélectionner Pays',
  ENTER_COMPANY_NAME: 'Saisir le nom de la société',
  ENTER_CITY: 'Saisir la ville',
  ENTER_COMPANY_ADDRESS: "Saisir l'adresse de la société",
  ENTER_POSTAL_CODE: 'Saisir ZIP/Code postal',
  ENTER_DESCRIPTION: 'Saisir la description',
  ENTER_SUBJECT: "Saisir l'objet",
  SELECT_STATUS: 'Sélectionner Statut',
  SELECT_PAYMAENT_METHOD: 'Sélectionner Méthode de paiement',
  SELECT_PAYMENT_TERMS: 'Sélectionner Conditions de paiement',
  SELECT_SETUP_FEE: "Sélectionner Frais d'installation",
  SELECT_SUBSCRIPTION_PACK: "Sélectionner Forfait d'abonnement",
  SELECT_SHIP_TO: 'Sélectionner Expédier à',
  SELECT_SHIPPING_CALCULATION: 'Sélectionner Calcul de livraison',
  SELECT_PRIORITY: 'Sélectionner Priorité',
  ENTER_YOUR_PASSWORD: 'Saisir votre mot de passe',
  ENTER_YOUR_USERNAME: "Saisir vore nom d'utilisateur",
  YOUR_ORDER_SAVED: 'Votre commande ci-dessous sera enregistrée',
  CONFIRMATION: 'Confirmation',
  REACTIVATE_SUPPLIER_MESSAGE:
    'Êtes-vous sûr(e) de vouloir réactiver ce fournisseur ?',
  SPLIT: 'Divisé',
  CONFIRMED_QUANTITY: 'Quantité confirmée',
  CART_PRESENT_MESSAGE:
    '*Il y a déjà une commande dans le panier. Merci de la passer depuis le panier, ou de la supprimer avant de créer une nouvelle commande ou d’ajouter des articles.',
  DELETE_PRODUCT_FROM_ORDER_CONFIRMATION:
    'Êtes-vous sûr(e) de vouloir supprimer ce produit de la commande ?',
  LOGGED_IN_SUCCESSFULLY: 'Connexion réussie',
  ENTER_NAME: 'Saisir le nom',
  DELETE_MESSAGE: 'Supprimer message',

  VIEW: 'Voir',
  DOWNLOADING_SHIPING_DETAILS: "Téléchargemebt des détails d'expédition",
  DOWNLOADING_INVOICE_DETAILS: 'Téléchargement des détails de la facture',
  DOWNLOADING_ORDER_HISTORY_DETAILS:
    'Téléchargement des détails de l’historique des commandes',
  PLEASE_TYPE_DELETE: 'Veuillez taper SUPPRIMER',
  ORDER_PRESENT_INCART:
    'Il y a déjà une commande dans le panier. Voulez-vous la remplacer ?',
  REQUESTED_DELIVERY_DATE_IS_REQUIRED:
    'La date de livraison demandée est requise',
  THIS_PRODUCT_IS_ALREADY_ADDED: 'Le produit a déjà été ajouté',
  THE_ORDER_IN_CART_AND_NEW_ORDER_ARE_SAME:
    'La commande dans le panier et la nouvelle commande sont identiques. Veuillez sélectionner l’une des options ci-dessous.',
  CONTINUE_WITH_CART: 'Continuer avec le panier',
  CREATE_NEW_ORDER: 'Créer une nouvelle commande',
  CANCEL_DELETE: 'Annuler/Supprimer',

  UNAVAILABLE: 'Temporairement indisponible',
  PROCESSED: 'Traité',
  PACKED: 'Emballé',
  BACKORDER: 'Commande en attente',
  INPRODUCTION: 'En production',
  SHIPPED: 'Délivré',
  INVOICED: 'Facturé',
  COMPLETE: 'Complété',
  CANCELLED: 'Annulé',
  REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE:
    'La date de livraison demandée doit être ultérieure à aujourd’hui ',
  USA: 'États-Unis',
  CANADA: 'Canada',
  // Canada State--
  ONTARIO: 'Ontario',
  QUEBEC: 'Québec',
  NOVA_SCOTIA: 'Nouvelle-Écosse',
  NEW_BRUNSWICK: 'Nouveau-Brunswick',
  MANITOBA: 'Manitoba',
  BRITISH_COLUMBIA: 'Colombie Britannique',
  PRINCE_EDWARD_ISLAND: 'Île-du-Prince-Édouard',
  SASKATCHEWAN: 'Saskatchewan',
  ALBERTA: 'Alberta',
  NEWFOUNDLAND_AND_LABRADOR: 'Terre-Neuve-et-Labrador',

  // USA State--
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'Californie',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  DISTRICT_OF_COLUMBIA: 'District de Colombia (Washington, D.C.)',
  FLORIDA: 'Floride',
  GEORGIA: 'Géorgie',
  HAWAII: 'Hawaï',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiana',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'Nouveau-Mexique',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'Caroline du Nord',
  NORTH_DAKOTA: 'Dakota du Nord',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'Caroline du Sud',
  SOUTH_DAKOTA: 'Dakota du Sud',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginia',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'Virginie-Occidentale',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming',

  STORE: 'Client',
  PICKUP: 'Retrait',
  OTHER: 'Autre',
  PERCENTAGE: 'Pourcentage',
  AMOUNT: 'Quantité',
  MESSAGE_TO: 'Message à',
  ORDER_CREATED_SUCCESS: 'Commande créée avec succès',
  ORDER_CREATION_FAILED: 'Échec création commande',
  FETCHING_COUNTRIES: 'Récupération des pays en cours ...',
  NO_STORE_NOTES_AVAILABLE: 'Aucune Remarque Client disponible',
  SHIPPING_CHARGE_PERCENTAGE: 'FShipping charge Percentage',
  SHIPPING_CHARGE_AMOUNT: 'FShipping charge Amount',
  POWERED_BY_ORDER_EZ: 'FPowered by Order-EZ.com',
  NO_SUPPLIER_NOTE_AVAILABLE: 'FNo Supplier note available',
  ADDING_NEW_SHIPPING_METHOD: 'FAdding new shipping method...',
  ADDING_NEW_TAX: 'FAdding New Tax',
};
